import { Button, Stack } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import useGlobalContext from "../../../hooks/useGlobalContext.js";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { isOfGoogleFlightsOrigin, isOfMetaOrigin } from "../../../utils/marketing-url-params.js";
import { actions as extraProductActions } from "../../../ancillaries/store/extraProducts/actions.js";
import FlightCardPrice from "../FlightCard/components/FlightCardPrice.js";
import useGetUrlParams from "../../../hooks/useGetUrlParams.js";
import Frame from "../Frame/index.js";
import { PRE_OPTED_ANCILLARIES_QUERY_PARAMS } from "../../../constants.js";
import styles from "./FlightDetailsInner.desktop.module.css";
import { useDispatch } from "react-redux";
import { getSirfStatus } from "../../../store/selectors/sirf.js";
import { useSplitBoundsCondition } from "../../../utils/experiments/funnel/flights_split_bounds_us.js";
import { SirfEligibilityMessage } from "./components/FlightDetailsInfo/Items/SIRF/SirfEligibilityMessage.js";
import tph_flights_price_discrepancy_aa from "../../../utils/experiments/funnel/tph_flights_price_discrepancy_aa.js";
const FlightDetailsFooterDesktop = ({ flight, onButtonClick, fullPadding = false, fetchStatus, isLoggedInAuthLow }) => {
    const i18n = useI18n();
    const history = useHistory();
    const [breakdownOpen, setBreakdownOpen] = useState(false);
    const { features } = useGlobalContext();
    const enableGfsPosMismatch = features["FLIGHTS_META_ENABLE_GFS_FOR_POS_MISMATCH"] && isOfGoogleFlightsOrigin();
    const dispatch = useDispatch();
    const { getUrlParam } = useGetUrlParams();
    const isFlexTicket = !!getUrlParam(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.flexibleTicket);
    const isCfarTicket = !!getUrlParam(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.cancelForAnyReason);
    const { isSplitBounds } = useSplitBoundsCondition();
    const sirfStatus = flight?.subsidizedFares ? getSirfStatus(flight?.subsidizedFares) : undefined;
    const handleBreakdownOpen = React.useCallback((status) => {
        setBreakdownOpen(status);
    }, []);
    useEffect(() => {
        if (isFlexTicket) {
            extraProductActions.addPreOptInProduct("flexibleTicket", true);
            return;
        }
        if (isCfarTicket) {
            extraProductActions.addPreOptInProduct("cancelForAnyReason", true);
            return;
        }
        extraProductActions.removePreOptInProduct("flexibleTicket");
        extraProductActions.removePreOptInProduct("cancelForAnyReason");
    }, [dispatch, isFlexTicket, isCfarTicket]);
    const showSirfEligibilityMessage = !!sirfStatus;
    useEffect(() => {
        if (fetchStatus !== "success" || !flight)
            return;
        const wishlistPriceParam = getUrlParam("wishlistPrice");
        const adplat = getUrlParam("adplat");
        if (!wishlistPriceParam || !adplat || !adplat.includes("wishlist-flight")) {
            return;
        }
        const [priceStr, currency] = wishlistPriceParam.split("_");
        const wishlistValue = Number(priceStr);
        if (!currency || isNaN(wishlistValue))
            return;
        const fdTotal = flight.priceBreakdown.total;
        if (fdTotal.currencyCode !== currency)
            return;
        if (!isLoggedInAuthLow())
            return;
        tph_flights_price_discrepancy_aa.goals.flight_details_price_loaded();
        const fdValue = fdTotal.units * 1e9 + fdTotal.nanos;
        if (wishlistValue === fdValue) {
            tph_flights_price_discrepancy_aa.goals.price_match();
            tph_flights_price_discrepancy_aa.goalsWithValue.tph_flights_price_match_count(1);
        }
        else if (wishlistValue > fdValue) {
            tph_flights_price_discrepancy_aa.goals.price_mismatch_wishlist_higher();
            tph_flights_price_discrepancy_aa.goalsWithValue.tph_flights_price_mismatch_wishlist_higher_count(1);
        }
        else {
            tph_flights_price_discrepancy_aa.goals.price_mismatch_wishlist_lower();
            tph_flights_price_discrepancy_aa.goalsWithValue.tph_flights_price_mismatch_wishlist_lower_count(1);
        }
        const params = new URLSearchParams(window.location.search);
        params.delete("wishlistPrice");
        history.replace(`${window.location.pathname}?${params.toString()}${window.location.hash}`);
    }, [fetchStatus, flight, getUrlParam, history, isLoggedInAuthLow]);
    return (React.createElement(Frame, { direction: "column", p: fullPadding ? 6 : undefined, className: `${fullPadding ? styles.footerBorder : styles.footer}` },
        React.createElement(Stack, { direction: "column", gap: 0, className: styles.footerContainerWithMessages },
            showSirfEligibilityMessage && React.createElement(SirfEligibilityMessage, { status: sirfStatus }),
            React.createElement(Frame, { direction: "row", alignItems: "center" },
                React.createElement("div", { className: styles.priceWrapper, "data-testid": "flight_details_inner_modal_footer" }, !!flight && (React.createElement(FlightCardPrice, { flight: flight, isRenderedInModal: true, alignment: "start", totalPriceLabel: i18n.trans(t("flights_fd_price_multi")), breakdownOpen: breakdownOpen, setBreakdownOpen: handleBreakdownOpen, showTotalPriceIncludingAncillaries: true, showAvailableSeats: isOfMetaOrigin() && (flight.travellers?.length || 1) <= 2, showPricePerPerson: false, isFlexTicket: isFlexTicket, isCfarTicket: isCfarTicket, popoverCloseAriaLabel: i18n.trans(t("flights_a11y_price_breakdown_close_fd")) }))),
                React.createElement("div", { "data-testid": "flight_details_inner_modal_select_button" },
                    React.createElement(Button, { text: i18n.trans(t("flights_details_select_button")), size: "large", onClick: onButtonClick, loading: !flight || (!enableGfsPosMismatch && flight.posMismatch?.isPOSMismatch), loadingAriaLabel: isSplitBounds ? i18n.trans(t("a11y_flights_fd_cta_spinner_loading")) : "" }))))));
};
export default FlightDetailsFooterDesktop;
